// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".abb-column-scroller .abb-table tbody tr td input{height:21px !important}\n", ""]);
// Exports
module.exports = exports;
